module.exports = __webpack_public_path__ + "static/media/mouse-pointer-solid.fb004197.svg";